<template>
  <Loading :loading="loading">
    <div class="discountPartner">
      <div class="container">
        <div class="row">
          <Breadcrumbs/>
        </div>
      </div>
      <div class="row">
        <!-- Get content for page -->
        <!-- Catch loaded event from wordpress and then show content -->
        <WordpressContentPage
          pageSlug="discount-partners-top"
          class="col-12"
          :showLoading="false"
          v-on:loaded="wpContentLoaded"
        />
      </div>	  
      <div class="no-lr-margin row col-12">
        <CustomButton class="app col-12 col-sm-2 offset-sm-3" link="https://play.google.com/store/apps/details?id=com.vghybrid.cherrytree&hl=en&fbclid=IwAR3OdSK7Ic6qOjNkWZd6fbn5eZVURWt1b92nHwcYZul7re1laso5tDdPy74">
          Android
        </CustomButton>
        <CustomButton class="app col-12 col-sm-2 offset-sm-2" link="https://itunes.apple.com/nz/app/cherrytree-members/id1440874484?mt=8&fbclid=IwAR2ThUf4blu6GYwiNg5T5jwWWpCZICo5QHvN50rpYl63BvkMlN_0i5CsJYY">
          IOS
        </CustomButton>
      </div>
      <div class="container">
        <div class="row">
          <div
            v-for="location in locations"
            class="col-12 col-sm-6 col-md-3 text-center discountPartnerItem"
            :key="location.id"
          >
            <router-link :to="{name:'discountPartnerLocation', params:{location: location.id}}">
              <div class="title">{{location.category}}</div>
              <img :src="image(location.filename)">
              <div class="btn btn-primary">Learn More</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Loading>
</template>

<script>
import WordpressContentPage from "@/wordpress/WordpressContentPage";
import Loading from "@/components/loading/Loading";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import CustomButton from "@/components/buttons/CustomButton";

export default {
  name: "MemberBiz",
  components: {
    WordpressContentPage,
    Loading,
    Breadcrumbs,
    CustomButton
  },
  data() {
    return {
      //loading is true until wordpress content has loaded
      loading: true
    };
  },
  created() {},
  methods: {
    image(filename) {
      // let defaultImg = "";
      let base = "/resources/images/content/";

      return base + filename;
    },
    wpContentLoaded() {
      this.loading = false;
    }
  },
  computed: {
    locations() {
      if (this.$store.state.reference.categories) {
        //this is hardcoded to get the locations of discount partners
        return this.$store.state.reference.categories["1635"].children;
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
.discountPartnerItem {
  text-align: center;
  position: relative;
  margin-bottom: 20px;

  div.title {
    &:hover {
      text-decoration: underline;
    }
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    text-decoration: none;
    color: $CTred;
    font-weight: bold;
    font-size: 1.3em;
    display: block;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
  }
  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto 10px;
    border-radius: $imageRounding;
  }
}

@include media-breakpoint-down(md){
  .discountPartnerItem{
    margin-bottom: 30px;
    margin-top: 20px;
  }
}

.app{
  margin-bottom: 30px;
}

.no-lr-margin{
  margin-left: 0;
  margin-right: 0;
}
</style>
